import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from 'components/Sidebar';
import Navbar from 'components/Navbar';

// Dimensões do drawer (correspondente ao drawerWidth da configuração anterior)
const drawerWidth = 280;

const Layout = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();

  // Verificar se é mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };
    
    // Verificar tamanho inicial
    checkIsMobile();
    
    // Adicionar listener para redimensionamento
    window.addEventListener('resize', checkIsMobile);
    
    // Limpar listener no desmonte
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  // Fechar sidebar automaticamente em mobile
  useEffect(() => {
    if (isMobile) {
      setIsSidebarOpen(false);
    } else {
      setIsSidebarOpen(true);
    }
  }, [isMobile]);

  return (
    <div className="flex h-screen overflow-hidden bg-background">
      {/* Navbar - Usando o componente separado */}
      <Navbar 
        isSidebarOpen={isSidebarOpen} 
        setIsSidebarOpen={setIsSidebarOpen} 
        isMobile={isMobile} 
      />

      {/* Sidebar */}
      <Sidebar 
        isSidebarOpen={isSidebarOpen} 
        setIsSidebarOpen={setIsSidebarOpen} 
        isMobile={isMobile}
        drawerWidth={drawerWidth}
      />

      {/* Main Content */}
      <main 
        className={`flex-1 overflow-auto pt-16 transition-all duration-300 ease-in-out`}
        style={{ 
          marginLeft: isSidebarOpen && !isMobile ? `${drawerWidth}px` : '0' 
        }}
      >
        <div className="p-4 md:p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;